import { useContext } from "react"
import { Mostrar } from "../Context/Mostrando"


function Botones(dato:any)
{
    const {Actualizar}=useContext(Mostrar)

    

    return (
        <>
            <div className="col-12 col-ms-6 col-md-3 mb-3">
                    <div className={dato.dato.ClassNameColor} style={{backgroundImage:dato.dato.imagen}}>
                        <div className="card-body">
                            <h5 className="card-title">{dato.titulo}</h5>
                            <button type="button" className={dato.dato.ClassBoton} style={dato.dato.estilo} onClick={()=> dato.actualiza>-1?Actualizar(dato.actualiza):null} >
                            <span className="btn-label"><i className={dato.dato.ClassNameIcono} ></i> </span>{" "+dato.dato.Subtitulo}</button>
                            
                        </div>
                    </div>    
            </div>
        </>
    )
}

export default Botones